export default __webpack_public_path__ + "static/sloth_card_1-86aa3d6a39d7690ea918ec1eb1217cdf.png";